module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-bingdao.691eac48.webm";